import styled from 'styled-components';
import { Text } from '@grupoboticario/flora-react';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  @media (max-width: 767px) {
    padding: 0px 0px 72px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 136px);
  height: fit-content;
  padding: 0 15px 15px;
  width: 100%;
  max-width: 570px;
  margin: auto;
`;

export const ButtonWrapper = styled.div`
  margin: 0 auto;
  button.sair,
  button.enviar {
    display: inline-block;
    margin: 10px;
    & svg {
      margin: 0 0 3px 10px;
      vertical-align: middle;
    }
    & svg path {
      fill: #fff;
    }
    & svg.disabled path {
      fill: #878787;
    }
  }
`;

export const Title = styled.div`
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: ${({ theme }) => theme.colors.textLight};
  width: 100%;
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.textLight};
  margin: 30px 0 20px;
  & span {
    display: block;
    width: fit-content;
    border-bottom: 2px solid ${({ theme }) => theme.colors.textLight};
  }
`;

export const Card = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.32);
  border-radius: 4px;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  .card {
    &-text {
      flex: 1;
      min-width: 33.3%;
      padding: 13px 10px;
      border-right: 1px solid ${({ theme }) => theme.colors.line};
      p {
        font-size: 10px;
        font-weight: 500;
        line-height: 14px;
        text-align: center;
        margin-bottom: 14px;
      }
    }
    &-title {
      display: block;
      color: ${({ theme }) => theme.colors.error};
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 18px;
      letter-spacing: 0em;
      text-align: left;
      margin-bottom: 13px;
      text-transform: uppercase;
    }
  }
  button.downloadButton {
    display: block;
    margin: auto;
    font-size: 14px;
    line-height: 16px;
  }
  svg.download {
    display: block;
    margin: 55px auto;
    fill: ${({ theme }) => theme.colors.main};
    box-sizing: content-box;
    padding: 16px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 2px solid ${({ theme }) => theme.colors.main};
  }
  @media (max-width: 570px) {
    flex-direction: column;
    svg.download {
      margin: 9px auto;
    }
    div.card-text {
      width: 100%;
    }
    div.card-text {
      padding: 24px 24px;
      border-right: 0;
      border-bottom: 1px solid ${({ theme }) => theme.colors.line};
      span.motivo {
        display: block;
        height: auto;
      }
    }
  }
`;

export const Label = styled.div`
  position: relative;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: left;
  padding: 0px 7px;
  border-left: 0.5px solid ${({ theme }) => theme.colors.line};
  margin-bottom: 17px;
  color: #000000;
  p {
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ModalText = styled(Text)`
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  svg {
    display: block;
    margin: 0px auto 15px;
    fill: ${({ theme }) => theme.colors.success};
    box-sizing: content-box;
    width: 55px;
    height: 55px;
  }
`;

export const ModalTitle = styled(Text)`
  font-weight: 700;
  display: block;
  margin-bottom: 20px;

  font-family: inherit;
`;

export const CircleStep = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0em;
  text-align: center;
  border-radius: 26px;
  width: 26px;
  height: 26px;
  line-height: 26px;
  color: #fff;
  background-color: ${({ theme }) => theme.colors.error};
  display: inline-block;
  margin-right: 9px;
`;

export const CardDeclarationRadio = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 17px;
  div.radioBlock {
    flex: 1;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: ${({ theme }) => theme.colors.text};
    button[role='radio'] {
      vertical-align: top;
      margin: 0 4px;
    }

    button[role='radio'][data-state='checked'] {
      span::after {
        background-color: var(--flora--colors-actionableDefault);
      }
    }
  }
  label {
    //label eh o CardDeclarationRadioText, porem o Radio do flora forca um tamanho pra ele aqui
    font-size: 10px;
  }
`;

export const CardDeclarationRadioText = styled(Text)`
  display: inline-block;
  max-width: calc(100% - 25px);
  width: 100%;
  vertical-align: top;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: ${({ theme }) => theme.colors.text};
`;

export const TextArea = styled.div`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.textLight};
  padding: 8px;
  height: 80px;
  textarea {
    width: 140px;
    height: 50px;
    font-size: 10px;
    resize: none;
    border: none;
    outline: none;
  }
  &.disabled {
    opacity: 0.5;
  }
`;

export const NoUpload = styled.div`
  div.card-text & p {
    font-size: 12px;
    line-height: 16px;
  }
  svg {
    display: block;
    margin: 10px auto;
    fill: ${({ theme }) => theme.colors.success};
    box-sizing: content-box;
    padding: 16px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 2px solid ${({ theme }) => theme.colors.success};
  }
`;
